import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {getDimensions, SIZE} from '../../utils/IntegrationIconSizer';

export const JiraIcon = ({size, onClick}) => {
	const dimensions = getDimensions(size);

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan onClick={handleClick} width={dimensions} height={dimensions}>
			<svg
				width={dimensions}
				height={dimensions}
				viewBox="57.5 57.5 135 135"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#jiraicon)">
					<path
						d="M188.428 121.252L130.608 63.6301L125.006 58.0466L81.4807 101.423L61.5776 121.252C60.5835 122.248 60.0254 123.595 60.0254 125C60.0254 126.405 60.5835 127.752 61.5776 128.748L101.342 168.376L125.006 191.953L168.525 148.577L169.203 147.907L188.428 128.778C188.926 128.285 189.322 127.699 189.591 127.053C189.861 126.407 190 125.714 190 125.015C190 124.315 189.861 123.623 189.591 122.977C189.322 122.331 188.926 121.745 188.428 121.252ZM125.006 144.799L105.139 125L125.006 105.201L144.867 125L125.006 144.799Z"
						fill="#2684FF"
					/>
					<path
						d="M125.006 105.201C118.758 98.9754 115.235 90.5389 115.208 81.734C115.181 72.929 118.652 64.4713 124.862 58.208L81.3906 101.512L105.049 125.089L125.006 105.201Z"
						fill="url(#paint0_linear)"
					/>
					<path
						d="M144.921 124.946L125.006 144.799C131.278 151.051 134.801 159.53 134.801 168.37C134.801 177.211 131.278 185.689 125.006 191.941L168.597 148.523L144.921 124.946Z"
						fill="url(#paint1_linear)"
					/>
				</g>
				<defs>
					<linearGradient
						id="paint0_linear"
						x1="121.449"
						y1="85.1686"
						x2="93.8007"
						y2="112.906"
						gradientUnits="userSpaceOnUse"
					>
						<stop offset="0.18" stopColor="#0052CC" />
						<stop offset="1" stopColor="#2684FF" />
					</linearGradient>
					<linearGradient
						id="paint1_linear"
						x1="5122.74"
						y1="5871.12"
						x2="7949.84"
						y2="7710.21"
						gradientUnits="userSpaceOnUse"
					>
						<stop offset="0.18" stopColor="#0052CC" />
						<stop offset="1" stopColor="#2684FF" />
					</linearGradient>
					<clipPath id="jiraicon">
						<rect width="130" height="134" fill="white" transform="translate(60 58)" />
					</clipPath>
				</defs>
			</svg>
		</StyledSpan>
	);
};

JiraIcon.SIZE = SIZE;
JiraIcon.propTypes = {
	onClick: PropTypes.func,
	size: PropTypes.oneOf(Object.values(SIZE)),
};

const StyledSpan = Styled.div`
	display: inline;
	cursor: ${props => (props.onClick ? 'pointer' : 'default')};
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
`;
